import { useEffect } from 'react';
import { Outlet, createRootRoute } from '@tanstack/react-router';
import { DevAuthFrame } from '@/components/dev-user-switcher';
import { AuthProvider, authMode, useAuth } from '@/contexts/auth';
import { identifyUser } from '@/lib/posthog';

export const Route = createRootRoute({
  component: RootShell,
});

function PostHogIdentity() {
  const { user } = useAuth();

  useEffect(() => {
    if (user) identifyUser(user.id, { email: user.email, name: [user.first_name, user.last_name].join(' ').trim() });
  }, [user]);

  return null;
}

function RootShell() {
  return (
    <AuthProvider>
      <PostHogIdentity />
      {authMode === 'dev' ? (
        <DevAuthFrame>
          <Outlet />
        </DevAuthFrame>
      ) : (
        <Outlet />
      )}
    </AuthProvider>
  );
}
